import React, { FC } from 'react';
import cn from 'classnames';
import { IPriceSizes, PriceSizes } from '..';
require("./PriceCurrentValue.css");
var styles = {
  "Root": "PriceCurrentValue-module-Root_2ch",
  "lSize": "PriceCurrentValue-module-lSize_2U6",
  "mSize": "PriceCurrentValue-module-mSize_272"
};
export const PriceCurrentValue = ({
  value,
  size = PriceSizes.m
}) => {
  return /*#__PURE__*/React.createElement("span", {
    className: cn(styles.Root, styles[`${size}Size`])
  }, value.toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  }));
};